import { Tag } from 'antd';

export const PROFILE_STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái hồ sơ' },
  { value: 'DRAFT', label: 'Bản nháp' },
  { value: 'PENDING_REVIEW', label: 'Chờ duyệt' },
  { value: 'NEEDS_CHANGES', label: 'Cần bổ sung' },
  { value: 'APPROVED', label: 'Đã duyệt' },
  { value: 'REJECTED', label: 'Từ chối' },
  { value: 'SUSPENDED', label: 'Tạm ngưng' },
];

export const PROFILE_STATUS_META = {
  DRAFT: ['Bản nháp', 'default'],
  PENDING_REVIEW: ['Chờ duyệt', 'processing'],
  NEEDS_CHANGES: ['Cần bổ sung', 'warning'],
  APPROVED: ['Đã duyệt', 'success'],
  REJECTED: ['Từ chối', 'error'],
  SUSPENDED: ['Tạm ngưng', 'default'],
};

export const ACCOUNT_STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái tài khoản' },
  { value: 'NORMAL', label: 'Đang hoạt động' },
  { value: 'SUSPENDED', label: 'Đã khoá' },
];

export const ACCOUNT_STATUS_META = {
  REGISTERED: ['Chưa kích hoạt', 'default'],
  NORMAL: ['Đang hoạt động', 'success'],
  SUSPENDED: ['Đã khoá', 'error'],
  DELETED: ['Đã xoá', 'default'],
};

export function RideDriverProfileStatusTag({ status }) {
  const [label, color] = PROFILE_STATUS_META[status] || [status || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export function RideDriverAccountStatusTag({ status }) {
  const [label, color] = ACCOUNT_STATUS_META[status] || [status || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const TRIP_STATUS_META = {
  DRAFT: ['Bản nháp', 'default'],
  PUBLISHED: ['Đang mở', 'processing'],
  BOARDING: ['Đang đón khách', 'processing'],
  IN_PROGRESS: ['Đang chạy', 'processing'],
  COMPLETED: ['Hoàn thành', 'success'],
  CANCELLED: ['Đã huỷ', 'error'],
  EXPIRED: ['Hết hạn', 'default'],
  DRIVER_NO_SHOW: ['Tài xế không đến', 'error'],
};

export function RideDriverTripStatusTag({ status }) {
  const [label, color] = TRIP_STATUS_META[status] || [status || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}

export const getRideDriverErrorMessage = (error) => error?.response?.data?.message
  || error?.response?.data?.reason
  || 'Không thể xử lý yêu cầu tài xế';
